// Personnalisation : textes affichés sur le nez et sur la main (fonctionnalité
// destinée à être débloquée via Telegram Stars). Objet mutable lu en direct par
// le jeu ; persisté en localStorage. La saisie (temporaire, pour tester) est
// câblée dans main.ts.

export interface CustomText {
  nose: string;
  hand: string;
}

const KEY = "the-big-dig.custom";
export const MAX_LEN = 8; // garde-fou d'harmonie : texte court

export const customText: CustomText = load();

function load(): CustomText {
  try {
    const j = JSON.parse(localStorage.getItem(KEY) || "{}");
    return { nose: clamp(j.nose), hand: clamp(j.hand) };
  } catch {
    return { nose: "", hand: "" };
  }
}

function clamp(v: unknown): string {
  return typeof v === "string" ? v.slice(0, MAX_LEN) : "";
}

export function setCustom(field: keyof CustomText, value: string): void {
  customText[field] = clamp(value);
  try {
    localStorage.setItem(KEY, JSON.stringify(customText));
  } catch {
    /* stockage indisponible */
  }
}
